export default "__VITE_ASSET__pNgbvjRm__"